import React from "react";

const WindowCloseIcon = ({ onClick }) => (
  <svg
    onClick={onClick}
    style={{
      width: "24px",
      height: "24px",
      position: "relative",
      marginLeft: "auto",
      marginRight: "15px",
      marginTop: "15px",
      cursor: "pointer"
    }}
    viewBox="0 0 24 24"
  >
    <path
      fill="#000000"
      d="M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z"
    />
  </svg>
);

export default WindowCloseIcon;



// WEBPACK FOOTER //
// ./src/components/NavBar/WindowCloseIcon/index.js